<template>
  <header class="sn-bs-header sn-bs-header--bg">
    <div class="sn-bs-header__title-container">
      <h1 class="sn-bs-header__title">{{ title }}</h1>
    </div>
    <div class="sn-bs-header__close-btn" @click="toHome">
      <i class="el-icon-close"></i>
    </div>
  </header>
</template>

<script>
export default {
  name: "BsHeader",
  props: {
    title: {
      type: String,
      default: "上海正义园艺有限公司",
    },
  },
  methods: {
    toHome() {
      location.href = "/index.html";
    },
  },
};
</script>

<style scoped lang="scss">
@include bs(header) {
  position: relative;
  width: 100%;
  height: 95px;
  z-index: 20;
  @include m(bg) {
    background: url("~@/assets/images/bs/layout-header-bg.png") no-repeat;
    background-size: 100% 100%;
    filter: drop-shadow(0px 15px 10px rgba(0, 0, 0, 0.5));
  }
  @include e(title-container) {
    @include utils-full-box();
    @include utils-vertical-center();
    text-align: center;
  }
  @include e(title) {
    display: inline-block;
    font-size: 40px;
    line-height: 2.2;
    color: $--color-white;
    font-weight: bold;
  }
  @include e(close-btn) {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 44px;
    height: 44px;
    line-height: 44px;
    cursor: pointer;
    text-align: center;
    border-top-left-radius: 22px;
    border-bottom-left-radius: 22px;
    background-color: rgba(30, 108, 72, 0.2);
    .el-icon-close {
      margin-left: 5px;
      font-size: $--font-size-base;
      font-weight: bold;
      color: $--color-danger;
    }
  }
}
</style>
